import { BrowserRouter as Router, Route, Routes } from 'react-router';
import baseTheme from 'themes/baseTheme';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import ActivityLog from 'views/ActivityLog';
import Analytics from 'views/Analytics';
import ControlCenter from 'views/ControlCenter';
import Dashboard from 'views/Dashboard/Dashboard';
import { HelpPage } from 'views/HelpPage';
import LoginPage from 'views/LoginPage';
import ManageDevices from 'views/ManageDevices';
import ManageTeams from 'views/ManageTeams';
import { SlatesDashboard } from 'views/SlatesDashboard';

import AppWrapper from 'components/Common/AppWrapper';
import PrivateRoute from 'components/Common/PrivateRoute';

import {
	ActivityLogAllowedRoles,
	AnalyticsAllowedRoles,
	ControlCenterAllowedRoles,
	DashboardAllowedRoles,
	DeviceAllowedRoles,
	HelpAllowedRoles,
	ManageTeamsAllowedRoles,
} from 'constants/AccessConstants';
import { ROUTE_KEY, ROUTE_PATH } from 'constants/RouteConstants';

import { configureAmplify } from 'utils/helpers';

configureAmplify();
function App(): JSX.Element {
	return (
		<ThemeProvider theme={baseTheme}>
			<CssBaseline />
			<AppWrapper>
				<Router>
					<Routes>
						<Route path="/" element={<LoginPage />} />

						<Route
							path={ROUTE_PATH[ROUTE_KEY.DASHBOARD]}
							element={<PrivateRoute allowedRoles={DashboardAllowedRoles} component={<Dashboard />} />}
						/>
						<Route
							path={`${ROUTE_PATH[ROUTE_KEY.CONTROL_CENTER]}/:eventId`}
							element={<PrivateRoute allowedRoles={ControlCenterAllowedRoles} component={<ControlCenter />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.CONTROL_CENTER]}
							element={<PrivateRoute allowedRoles={ControlCenterAllowedRoles} component={<ControlCenter />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.CONTROL_CENTER]}
							element={<PrivateRoute allowedRoles={ControlCenterAllowedRoles} component={<ControlCenter />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.MANAGE_TEAMS]}
							element={<PrivateRoute allowedRoles={ManageTeamsAllowedRoles} component={<ManageTeams />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.ACTIVITY_LOG]}
							element={<PrivateRoute allowedRoles={ActivityLogAllowedRoles} component={<ActivityLog />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.ANALYTICS]}
							element={<PrivateRoute allowedRoles={AnalyticsAllowedRoles} component={<Analytics />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.DEVICES]}
							element={<PrivateRoute allowedRoles={DeviceAllowedRoles} component={<ManageDevices />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.SLATES]}
							element={<PrivateRoute allowedRoles={DashboardAllowedRoles} component={<SlatesDashboard />} />}
						/>
						<Route
							path={ROUTE_PATH[ROUTE_KEY.HELP]}
							element={<PrivateRoute allowedRoles={HelpAllowedRoles} component={<HelpPage />} />}
						/>
					</Routes>
				</Router>
			</AppWrapper>
		</ThemeProvider>
	);
}

export default App;
